<template>
  <div class="main">
    <link
        href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
        rel="stylesheet"
        integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
        crossorigin="anonymous"
    >
    <data-table v-bind="bindings"/>
  </div>

</template>

<script>

import {mapGetters} from "vuex";

import ActionButtons from "@/components/table/ActionButtons";
import phoneColumn from "@/components/table/phoneColumn";
import partnerColumn from "@/components/table/partnerColumn";
import statusColumn from "@/components/table/statusColumn";
import dateColumn from "@/components/table/dateColumn";
import commWelderColumn from "@/components/table/commWelderColumn";
import commCustomerColumn from "@/components/table/commCustomerColumn";

export default {
  name: "vue-table",

  props: {
    data_table: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    ...mapGetters(['meRoles']),

    bindings() {
        const columns = [
          {
            key: "Id",
            title: "Индекс",
            sortable: false,
            searchable: false,
          }, {
            key: "date",
            title: "Дата",
            searchable: false,
            component: dateColumn
          },
          {
            key: "city",
            title: "Город",
            // component: cityColumn
          }, {
            key: "site",
            title: "Сайт",
            sortable: true,
          },

          {
            key: "phone",
            title: "Телефон",
            sortable: false,
            component: phoneColumn

          },
          {
            key: "partner_id",
            title: "Партнер",
            component: partnerColumn
          },
          {
            key: "status",
            title: "Статус",
            sortable: false,
            component: statusColumn
          }, {
            key: "comm_customer",
            title: "Комментарий Клиента",
            sortable: false,
            component: commCustomerColumn

          },

          {
            key: "comm_welder",
            title: "Комментарий Сверщика",
            sortable: false,
            component: commWelderColumn,
          },

          {
            title: "Действия",
            component: ActionButtons,
            sortable: false,
            searchable: false,
          }
        ];

      return {
        data: this.data_table,
        showEntriesInfo: false,
        actionMode: "multiple",
		defaultPerPage: 100,
		perPageSizes: [10, 25, 50, 100, 500],
        columns: columns,
        text: {
          downloadFileName: (new Date()).toLocaleDateString(),
          nextButtonText: "Дальше",
          perPageText: "Показать :entries записей",
          previousButtonText: "Назад",
          paginationSearchText: "Перейти на страницу",
          paginationSearchButtonText: "Перейти",
          searchText: "Поиск:",
          downloadText: "экспорт как:",
          downloadButtonText: "Скачать",
        }
      }
    },
  },

  methods: {
    handleAction(action, payload) {
      window.alert("check out the console to see the data logged");
    },
  },

}
</script>

<style scoped>
.main {
  padding: 32px;
}
</style>
